module.exports = __webpack_public_path__ + "img/voice.79e27358.svg";